import { ContentFilterType, ContentOrderType } from '@diritto/common/content/constants';

export enum ExploreNavigationMenu {
  All = 'All',
  New = 'New',
  UpcomingHidden = 'UpcomingHidden',
  Exclusive = 'Exclusive',
  CompletedOrPublished = 'CompletedOrPublished',
}

export const ExploreNavigationMenuDisplayList = [
  ExploreNavigationMenu.All,
  ExploreNavigationMenu.New,
  ExploreNavigationMenu.UpcomingHidden,
  ExploreNavigationMenu.Exclusive,
  ExploreNavigationMenu.CompletedOrPublished,
];

export const ExploreNavigationMenuText = {
  [ExploreNavigationMenu.All]: '전체',
  [ExploreNavigationMenu.New]: '신작',
  [ExploreNavigationMenu.UpcomingHidden]: '숨김 예정작',
  [ExploreNavigationMenu.Exclusive]: '독점',
  [ExploreNavigationMenu.CompletedOrPublished]: '완결 / 출간',
};

export const ExploreNavigationMenuPath = {
  [ExploreNavigationMenu.All]: 'all',
  [ExploreNavigationMenu.New]: 'new',
  [ExploreNavigationMenu.UpcomingHidden]: 'upcoming-hidden',
  [ExploreNavigationMenu.Exclusive]: 'exclusive',
  [ExploreNavigationMenu.CompletedOrPublished]: 'completed-or-published',
};

export enum ExploreSubMenu {
  LatestFirstOpenedAt = 'LatestFirstOpenedAt',
  LatestEpisodeOpenedAt = 'LatestEpisodeOpenedAt',
  FavoriteCount = 'FavoriteCount',
  Completed = 'Completed',
  Published = 'Published',
}

export const ExploreSubMenuText = {
  [ExploreSubMenu.LatestFirstOpenedAt]: '최신순',
  [ExploreSubMenu.LatestEpisodeOpenedAt]: '업데이트순',
  [ExploreSubMenu.FavoriteCount]: '좋아요순',
  [ExploreSubMenu.Completed]: '완결',
  [ExploreSubMenu.Published]: '출간',
};

export const ExploreSubMenuDisplayList = [ExploreSubMenu.LatestEpisodeOpenedAt, ExploreSubMenu.FavoriteCount];

export const ExploreSubMenuNewDisplayList = [ExploreSubMenu.LatestFirstOpenedAt, ExploreSubMenu.FavoriteCount];

export const ExploreSubMenuCompletedOrPublishedDisplayList = [ExploreSubMenu.Completed, ExploreSubMenu.Published];

export const getFilterAndOrderTypeByExplore = (exploreMenu: ExploreNavigationMenu, exploreSubMenu?: ExploreSubMenu) => {
  switch (exploreMenu) {
    case ExploreNavigationMenu.All:
      switch (exploreSubMenu) {
        case ExploreSubMenu.LatestEpisodeOpenedAt:
          return { filterType: ContentFilterType.All, orderType: ContentOrderType.LatestEpisodeOpenedAt };
        case ExploreSubMenu.FavoriteCount:
          return { filterType: ContentFilterType.All, orderType: ContentOrderType.FavoriteCount };
        default:
          throw new Error(`NotImplementedError: getFilterType ${exploreSubMenu}`);
      }
    case ExploreNavigationMenu.New:
      switch (exploreSubMenu) {
        case ExploreSubMenu.LatestFirstOpenedAt:
          return { filterType: ContentFilterType.New, orderType: ContentOrderType.LatestFirstOpenedAt };
        case ExploreSubMenu.FavoriteCount:
          return { filterType: ContentFilterType.New, orderType: ContentOrderType.FavoriteCount };
        default:
          throw new Error(`NotImplementedError: getFilterType ${exploreSubMenu}`);
      }
    case ExploreNavigationMenu.UpcomingHidden:
      return { filterType: ContentFilterType.UpcomingHidden, orderType: ContentOrderType.UpcomingHidden };
    case ExploreNavigationMenu.Exclusive:
      return { filterType: ContentFilterType.Exclusive, orderType: ContentOrderType.LatestEpisodeOpenedAt };
    case ExploreNavigationMenu.CompletedOrPublished:
      switch (exploreSubMenu) {
        case ExploreSubMenu.Completed:
          return { filterType: ContentFilterType.Completed, orderType: ContentOrderType.LatestEpisodeOpenedAt };
        case ExploreSubMenu.Published:
          return { filterType: ContentFilterType.Published, orderType: ContentOrderType.LatestEpisodeOpenedAt };
        default:
          throw new Error(`NotImplementedError: getFilterType ${exploreSubMenu}`);
      }
    default:
      throw new Error(`NotImplementedError: getFilterType ${getFilterAndOrderTypeByExplore}`);
  }
};

export const AllMenuTabs = ExploreSubMenuDisplayList.map((exploreSubMenu, index) => ({
  text: ExploreSubMenuText[exploreSubMenu],
  exploreSubMenu,
  order: index,
}));

export const NewMenuTabs = ExploreSubMenuNewDisplayList.map((exploreSubMenu, index) => ({
  text: ExploreSubMenuText[exploreSubMenu],
  exploreSubMenu,
  order: index,
}));

export const UpcomingHiddenMenuTabs: never[] = [];

export const ExclusiveMenuTabs: never[] = [];

export const CompletedOrPublishedMenuTabs = ExploreSubMenuCompletedOrPublishedDisplayList.map(
  (exploreSubMenu, index) => ({
    text: ExploreSubMenuText[exploreSubMenu],
    exploreSubMenu,
    order: index,
  }),
);

export const getExploreSubMenus = (exploreMenu: ExploreNavigationMenu) => {
  switch (exploreMenu) {
    case ExploreNavigationMenu.All:
      return AllMenuTabs;
    case ExploreNavigationMenu.New:
      return NewMenuTabs;
    case ExploreNavigationMenu.UpcomingHidden:
      return UpcomingHiddenMenuTabs;
    case ExploreNavigationMenu.Exclusive:
      return ExclusiveMenuTabs;
    case ExploreNavigationMenu.CompletedOrPublished:
      return CompletedOrPublishedMenuTabs;
    default:
      throw new Error(`NotImplementedError: getFilterType ${getFilterAndOrderTypeByExplore}`);
  }
};
